<template>
    <div class="c-box p-5">
        <div class="c-box__content">
            Please wait while we are logging you out
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Logout"
    },

    mounted() {
        this.logout();
    },

    props: {},

    data: function() {
        return {
            logout_in_progress: false,
            logout_success: false
        };
    },

    watch: {},

    computed: {},

    methods: {
        logout: function() {
            this.logout_in_progress = true;

            this.$store.dispatch("user/LogoutAsUser").then(
                (success_data) => {
                    this.logout_in_progress = false;
                    window.location.href = this.$router.resolve({ name: "account.information" }).href;
                },
                (error_data) => {
                    // redirect even here
                    window.location.href = this.$router.resolve({ name: "account.information" }).href;
                }
            );
        }
    }
};
</script>